import { JOURNEY } from "@/content";

export const Journey = () => (
  <section className="journey" id="servicos" data-testid="journey-section">
    <div className="wrap">
      <div className="section-head">
        <p className="eyebrow">{JOURNEY.eyebrow}</p>
        <h2>{JOURNEY.title}</h2>
        <p>{JOURNEY.intro}</p>
      </div>
      <div className="journey-grid">
        <div className="journey-flow">
          {JOURNEY.steps.map((step) => (
            <article key={step.number}>
              <span>{step.number}</span>
              <div>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </div>
            </article>
          ))}
          <a
            className="text-link"
            href={JOURNEY.whatsappCta.href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="journey-cta-whatsapp"
          >
            {JOURNEY.whatsappCta.label}
          </a>
          <a
            className="next-link"
            href={JOURNEY.nextLink.href}
            data-testid="journey-next-link"
          >
            {JOURNEY.nextLink.label}
          </a>
        </div>
      </div>
    </div>
  </section>
);
